"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeZipCode = exports.normalizeTelephone = exports.normalizeRooms = exports.normalizePrice = exports.normalizeData = exports.formatTelephone = exports.formatRooms = exports.formatPrice = void 0;
var _lodash = require("lodash");
var _get = _interopRequireDefault(require("lodash/get"));
var _has = _interopRequireDefault(require("lodash/has"));
var _helper = require("./helper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// PRICE FORMAT - use inputFormat = price
const formatPrice = (value, maxLengthNum, minLengthNum, prevValue, currency) => {
  if (!value && value !== 0) return '';
  let localString = 'de-CH';
  if (currency === 'EUR') localString = 'it-IT';
  const val = Number(value.toString().replace(/\D/g, ''));
  const preValue = prevValue ? Number(prevValue.toString().replace(/\D/g, '')) : '';
  if (minLengthNum && maxLengthNum) {
    if (!value && val !== 0 || minLengthNum > val || maxLengthNum < val) {
      return Number(preValue).toLocaleString(localString);
    }
  } else if (minLengthNum) {
    if (!value && val !== 0 || minLengthNum > val) {
      return Number(preValue).toLocaleString(localString);
    }
  } else if (maxLengthNum) {
    if (!value && val !== 0 || maxLengthNum < val) {
      return Number(preValue).toLocaleString(localString);
    }
  } else if (!value && val !== 0) {
    return Number(preValue).toLocaleString(localString);
  }
  return Number(val).toLocaleString(localString);
};
exports.formatPrice = formatPrice;
const normalizePrice = (value, maxLengthNum, minLengthNum, prevValue) => {
  let val = '';
  if (value) {
    val = Number(value.toString().replace(/\D/g, ''));
    if (minLengthNum && maxLengthNum) {
      if (value.toString().length === 0 || !value || minLengthNum > val || maxLengthNum < val) return prevValue;
    } else if (minLengthNum) {
      if (value.toString().length === 0 || !value || minLengthNum > val) return prevValue;
    } else if (maxLengthNum) {
      if (value.toString().length === 0 || !value || maxLengthNum < val) return prevValue;
    } else if (value.toString().length === 0 || !value) return prevValue;
  }
  return val;
};
// TELEPHONE - use inputFormat = tel
exports.normalizePrice = normalizePrice;
const formatTelephone = (value, prevValue) => {
  if (!value) return '';
  const val = value.toString().replace(/ /g, '');
  if (!(0, _lodash.isNaN)(+val) || (0, _get.default)(value, 'number', null)) {
    return value;
  }
  return prevValue;
};
exports.formatTelephone = formatTelephone;
const normalizeTelephone = (value, prevValue) => {
  const val = value ? value.toString().replace(/ /g, '') : '';
  if ((0, _lodash.isString)(val)) {
    if (val.length === 0 || !val) return '';
    const valFirst = val.charAt(0);
    const valSecond = val.charAt(1);
    const valSub = val.substr(1);
    if ((valFirst === '+' || !(0, _lodash.isNaN)(+valFirst)) && !(0, _lodash.isNaN)(+valSecond) && !(0, _lodash.isNaN)(+valSub)) {
      return (0, _helper.telephoneFormat)(value, false, true).replace(/ /g, '');
    }
  }
  return (0, _lodash.isObject)(prevValue) && (0, _has.default)(prevValue, 'number') ? prevValue.number : prevValue;
};
// ZIP CODE - format cip code
exports.normalizeTelephone = normalizeTelephone;
const normalizeZipCode = (value, countryCode = 'CH') => {
  if (!value) return '';
  const val = value.toString().replace(/[^\d]/g, '');
  if (countryCode.toLowerCase() === 'ch') {
    const newVal = val.slice(0, 4);
    if (+newVal <= 9999) {
      return newVal.toString();
    }
  } else {
    return value;
  }
  return null;
};
// ROOMS - use inputFormat = rooms-${countrycode lowercase}
exports.normalizeZipCode = normalizeZipCode;
const formatRooms = value => {
  if (!value && value !== 0) return '';
  return value;
};
exports.formatRooms = formatRooms;
const normalizeRooms = value => {
  return parseFloat(value.toString());
};
// FORMAT DATE MM-YYYY OR YYYY - use inputFormat = date-mm:yyyy or date-yyyy
exports.normalizeRooms = normalizeRooms;
const normalizeData = (value, format, prevValue) => {
  // if (!value) return value;
  let valueOnlyNumbers = value.toString().replace(/[^\d]/g, '');
  if (format === 'dd:mm:yyyy') {
    const day = valueOnlyNumbers.slice(0, 2);
    const month = valueOnlyNumbers.slice(2, 4);
    const year = valueOnlyNumbers.slice(4, 8);
    let newValue = value;
    if (valueOnlyNumbers.length < 2 && !(0, _lodash.isNaN)(+day) && +day <= 31) newValue = `${day}`;
    if (valueOnlyNumbers.length === 2 && !(0, _lodash.isNaN)(+day) && +day <= 31) newValue = `${day}/`;
    if (valueOnlyNumbers.length > 2 && valueOnlyNumbers.length < 5 && !(0, _lodash.isNaN)(+month) && +month <= 12) newValue = `${day}/${month}`;
    if (valueOnlyNumbers.length >= 5 && !(0, _lodash.isNaN)(+year) && +year <= 2090) newValue = `${day}/${month}/${year}`;
    return newValue;
  }
  if (format === 'mm:yyyy') {
    const month = valueOnlyNumbers.slice(0, 2);
    const year = valueOnlyNumbers.slice(2, 6);
    if (valueOnlyNumbers.length < 2 && (0, _lodash.isNumber)(+month) && +month <= 12) return `${month}`;
    if (valueOnlyNumbers.length === 2 && (0, _lodash.isNumber)(+month) && +month <= 12) return `${month}/`;
    if (valueOnlyNumbers.length > 2 && (0, _lodash.isNumber)(+year) && +year <= 2090) return `${month}/${year}`;
  }
  if (format === 'hh:mm') {
    valueOnlyNumbers = value.toString().replace(':', '');
    const hour = valueOnlyNumbers.slice(0, 2);
    const minutes = valueOnlyNumbers.slice(2, 4);
    if (valueOnlyNumbers.length === 2 && hour && !(0, _lodash.isNaN)(+hour) && +hour <= 24) return `${hour}:`;
    if (valueOnlyNumbers.length < 3 && !(0, _lodash.isNaN)(+hour) && +hour <= 24 && +hour >= 0) return `${hour}`;
    if (valueOnlyNumbers.length > 2 && minutes && !(0, _lodash.isNaN)(+minutes) && +minutes <= 59) return `${hour}:${minutes}`;
    if (!(0, _lodash.isNaN)(+valueOnlyNumbers)) return valueOnlyNumbers;
    return '';
  }
  if (format === 'yyyy') {
    const year = valueOnlyNumbers.slice(0, 4);
    if (!(0, _lodash.isNaN)(+year) && +year <= 2090) return `${year}`;
    return prevValue;
  }
  return null;
};
exports.normalizeData = normalizeData;